import { FC, PropsWithChildren } from 'react'
import { Button } from '@wellesley/ui'
import ActionsDropdown, { Action } from 'components/ActionsDropdown'

type OrganizerActionsProps = PropsWithChildren & {
  actions: Action[]
}

export const OrganizerActions: FC<OrganizerActionsProps> = ({ actions }) => {
  if (!actions?.length) {
    return null
  }

  const visibleActions = actions.slice(0, 2)
  const hiddenActions = actions.slice(2)

  return (
    <div
      className="grid grid-cols-[1fr_1fr_48px] gap-xs"
      data-testid="organizer-actions"
    >
      {visibleActions.map((action) => (
        <Button
          key={action.name}
          size="m"
          variant="secondary"
          onClick={action.handler}
          disabled={action?.disabled || false}
        >
          {action.icon}
          {action.name}
        </Button>
      ))}

      {!!hiddenActions?.length && (
        <ActionsDropdown
          actions={hiddenActions}
          mobileBehavior="modal"
          triggerVariant="secondary"
          triggerClass="rounded-m px-xs"
        />
      )}
    </div>
  )
}
